import { IItemForGetShortInfo } from 'types';
import {
	TCreateGameSelectedItem,
	TTypeOfCreateGameModalWindow,
} from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import React from 'react';
import DeveloperSelect from './components/DeveloperSelect';
import CreateDeveloperBtn from './components/CreateDeveloperBtn';
import style from './DeveloperField.module.scss';

interface IDeveloperField {
	setIDDeveloper: (value: TCreateGameSelectedItem) => void;
	setFetchedDevelopers: (value: IItemForGetShortInfo[]) => void;
	refetchDevelopers: (value: boolean) => void;
	needRefetchDevelopers: boolean;
	changeTypeOfModalWindow: (value: TTypeOfCreateGameModalWindow) => void;
}

const DeveloperField: React.FC<IDeveloperField> = ({
	needRefetchDevelopers,
	refetchDevelopers,
	setFetchedDevelopers,
	setIDDeveloper,
	changeTypeOfModalWindow,
}) => {
	return (
		<div className={style.container}>
			<DeveloperSelect
				needRefetchDevelopers={needRefetchDevelopers}
				setIDDeveloper={setIDDeveloper}
				refetchDevelopers={refetchDevelopers}
				setFetchedDevelopers={setFetchedDevelopers}
			/>
			<CreateDeveloperBtn changeTypeOfModalWindow={changeTypeOfModalWindow} />
		</div>
	);
};

export default React.memo(DeveloperField);
